import React, {Fragment, useState} from 'react'
import {Spin} from 'antd'
import TableHead from './data/TableHead'
import TableRow from './data/TableRow'
import emptyData from '../../../assets/images/empty-img-gray.png'
import RequestUpdatePagination from "./RequestUpdatePagination"

const RequestUpdateTable = (props) => {
    const {loading, requestUpdate} = props
    const [loadingSend, _setLoadingSend] = useState(false)

    return (
        <div className="RequestUpdateTable">
            <Spin spinning={loading} tip='Loading...'>
                {requestUpdate.length > 0 ? (
                    <div>
                        <table className='table'>
                            <TableHead/>
                            <tbody className="TableBody">
                            {
                                requestUpdate.map(request => {
                                    return (
                                        <Fragment key={request._id}>
                                            <TableRow
                                                loadingSend={loadingSend}
                                                handleSendLoading={_setLoadingSend}
                                                request={request}
                                                currentPage={1}
                                            />
                                        </Fragment>
                                    )
                                })
                            }
                            </tbody>
                        </table>
                        <RequestUpdatePagination {...props}/>
                    </div>
                ) : !loading && (
                    <div className="noData d-flex flex-column align-items-center justify-content-center">
                        <img src={emptyData} alt="No data"/>
                        No data!
                    </div>
                )}
            </Spin>
        </div>
    )
}

export default RequestUpdateTable
